var $ = require('jQuery');

/**
 * Merge fields.
 *
 * Click on any of the merge fields and paste its value into an input/textarea element that was last in focus.
 *
 * Usage:
 *   var mergeFiels = new MergeFields();
 *   mergeFields.setup(container, inputElements);
 * 
 */
module.exports = function() {

    var lastInputElementInFocus;
    var lastMarkdownEditorInFocus;

    /**
     * Track last markdown editor in focus. Forget tracked input/textarea element.
     *
     * inputElements -> a jQuery selector
     */
    var trackLastMarkdownEditorInFocus = function(inputElements) {
        $(inputElements).on('mdeFocus', function (e, editor, line, ch) {
            lastInputElementInFocus = null;
            lastMarkdownEditorInFocus = {editor: editor, line: line, ch: ch};
        });
    };

    /**
     * Track last input/textarea element in focus. Forget tracked markdown editor.
     *
     * inputElements -> a jQuery selector
     */
    var trackLastInputElementInFocus = function(inputElements) {
        $(inputElements).on('focus', function () {
            lastInputElementInFocus = $(this);
            lastMarkdownEditorInFocus = null;
        });
    };

    /**
     * A click handler that will be attached to merge fields (for use with input/textarea elements)
     *
     * event -> Event
     */
    var mergeFieldInputHandler = function (contentToAdd) {
        var caretPosition, content;

        if (!lastInputElementInFocus || !lastInputElementInFocus.length) {
            return;
        }

        // IE8 and below doesn't have these properties
        if  (!('selectionStart' in lastInputElementInFocus[0]) || !('selectionEnd' in lastInputElementInFocus[0])) {
            return;
        }

        // Find the current caret position
        caretPosition = lastInputElementInFocus[0].selectionStart;

        // Grab the values of the textarea and merge field
        content = lastInputElementInFocus.val();

        // Insert the merge field value into the textarea
        lastInputElementInFocus.val(content.substring(0, caretPosition) +
            contentToAdd + content.substring(caretPosition));

        // Adjust caret position
        lastInputElementInFocus[0].selectionStart = lastInputElementInFocus[0].selectionEnd =
            caretPosition + contentToAdd.length;

        // Return focus to the textarea
        lastInputElementInFocus.focus();
    };

    /**
     * A click handler that will be attached to merge fields (for use with markdown editors)
     *
     * event -> Event
     */
    var mergeFieldMarkdownEditorHandler = function (contentToAdd) {
      if (!lastMarkdownEditorInFocus) {
        return;
      }

      var editor = lastMarkdownEditorInFocus.editor;

        editor.setCursor({line: lastMarkdownEditorInFocus.line, ch: lastMarkdownEditorInFocus.ch});
        editor.getDoc().replaceRange(contentToAdd, editor.getCursor());
        editor.focus();
    };

    /**
     * Setup clickable merge fields
     *
     * container -> an id of a container element with merge fields
     * inputElements -> a jQuery selector identifying a single or multiple input/textarea elements
     */
    this.setup = function (container, inputElements) {
        inputElements = inputElements ? `${inputElements},.merge-fields-target` : '.merge-fields-target';
        var mergeFields = $('#'+container);

        trackLastInputElementInFocus(inputElements);
        trackLastMarkdownEditorInFocus(inputElements);

        if (mergeFields.length && mergeFields.children().length) {
            mergeFields.find('a').on('click', function () {
                var contentToAdd = $(this).data('merge-field');

                if (lastInputElementInFocus) {
                    mergeFieldInputHandler(contentToAdd);
                } else {
                    mergeFieldMarkdownEditorHandler(contentToAdd);
                }
            });
        }
    };

};
